import type { LocationBreadcrumbProps } from "./location-breadcrumb.type";

import AncestorsBreadcrumb from "@/modules/ancestors/ancestors-breadcrumb";

const LocationBreadcrumb = ({
  location,
  ...options
}: LocationBreadcrumbProps) => {
  return <AncestorsBreadcrumb {...options} ancestors={location?.ancestors} />;
};

export default LocationBreadcrumb;
